import type { ConditionsOf, UserInfo, matchesFn } from '@system/acl/types';

import {
  carriageGroupMatch,
  trailedDirectGroupMatch,
  trainMatch,
  trainSchemeMatch,
} from './matches';
import { trainScheduleMatch } from './matches/trainSchedule';

export class AclBuilder {
  readonly #matrix: Map<string, string[]>;
  readonly #matches: Map<string, matchesFn>;
  readonly #userInfo: UserInfo;

  constructor(matrix: Map<string, string[]>, userInfo: UserInfo) {
    this.#matrix = matrix;
    this.#userInfo = userInfo;
    this.#matches = new Map<string, matchesFn>();
    this.buildMatches();
  }

  private buildMatches(): void {
    trainMatch(this.#matches, this.#userInfo);
    carriageGroupMatch(this.#matches, this.#userInfo);
    trailedDirectGroupMatch(this.#matches, this.#userInfo);
    trainSchemeMatch(this.#matches, this.#userInfo);
    trainScheduleMatch(this.#matches, this.#userInfo);
  }

  public can<T extends object | undefined = undefined>(
    method: string,
    conditions?: ConditionsOf<T>,
  ): boolean {
    const module = method.split('.')[0];
    const rules = this.#matrix.get(module);

    const isAllowed = rules?.includes(method);

    if (isAllowed) {
      if (
        conditions &&
        Object.keys(conditions).length > 0 &&
        this.#matches.has(method)
      ) {
        const match = this.#matches.get(method);

        return match?.(conditions) ?? false;
      }
      return true;
    }

    return false;
  }
}
